<template>
	<div>
			<div class="pall14">
				<div class="w100 flex bz">
                    <div  class="whiteBorderRow flex">
                        <span  class="plr4">公司:</span>
                        <el-select  @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable filterable placeholder="请选择公司">
                            <el-option
                                    v-for="item in compsData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </div>
					<div class="whiteBorderRow flex ">
						<span class="plr4">班组：</span>
                        <el-select v-model="vc_gname" placeholder="请选择" size="mini" @change="bcChange" style="width: 200px"  class="plr4">
                            <el-option
                                    v-for="item in groupList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
					</div>
                    <div  class="whiteBorderRow flex">
                        <span  class="plr4">姓名:</span>
                        <el-select  class="plr4" size="mini" @change="nameChange"  filterable :remote="true" :remote-method="namesearch"  v-model="idpeople">
                            <el-option v-for="(val,index) in searchPeople"  :label="val.name+'('+val.department+')'" :value="JSON.stringify(val.departmentId)"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="w100 flex bz mt8">
                    <el-button class="colorjxsc Button" size="mini" @click="jxsc">机修时长</el-button>
                    <el-button class="colortzbc Button" size="mini" @click="tzbz">调整班次</el-button>
                    <el-button class="colortzsx Button" size="mini" @click="tzsx">调整顺序</el-button>
                    <el-button class="colorbmtz Button" size="mini" @click="bmtz">调整部门</el-button>
                    <el-button class="whiteBgButton " size="mini" @click="clearChoose">清除选中</el-button>
                    <el-button :class="['Button',baseerp+'btn']" size="mini" @click="fzbz">按日期复制班次</el-button>
                    <el-button :class="['Button',baseerp+'btn']" size="mini" @click="ryfzbz">按人员复制班次</el-button>
                </div>
                <div  class="p14 psr">
					<div class="daynote flex a-i-c">
                        <span>{{dayChoose?'当前选中日期:'+dayChoose:''}}</span>

					</div>

					<div class="uni-calendar__header">
						<el-button icon="el-icon-arrow-left" type="text" class="uni-calendar__header-btn-box" @click.stop="pre">

						</el-button>
						<span class=" blackFont">{{ymTxt}}</span>
						<el-button icon="el-icon-arrow-right" type="text" class="uni-calendar__header-btn-box" @click.stop="next">

						</el-button>
					</div>
                    <div class="pointnote flex a-i-c">
                        <div class="plr4">
                            <span class="uppoint"></span>
                            <span class="darkGrayFont">休上半工时</span>
                        </div>
                        <div>
                            <span class="lowpoint"></span>
                            <span class="darkGrayFont">休下半工时</span>
                        </div>
                        <div class="plr4">
                            <span class="ccz p4"></span>
                            <span class="darkGrayFont">产出外时长</span>
                        </div>
                        <div>
                            <span class="jx p4"></span>
                            <span class="darkGrayFont">计划检修时长</span>
                        </div>
                    </div>
                    <div class=" overBox">
                        <div class="calendarBox">
                            <div class="calendar center wbg">
                                <div class="tablebox center wbg">
                                    <div class="border flex w100" v-for="(item,weekIndex) in weekList" :key="weekIndex">
                                        <div :class="['week-day flex  a-i-c w100',item.day?'f-d-c':'',item.day&&dayChoose==item.ymd?'activeBg':'']" @click="chooseLine(item,weekIndex)">
                                            <div :class="['day w100',item.week=='六'||item.week=='日'?'zhoumo':'blackFont']" v-if="item.day">
                                                {{item.day}}
                                            </div>
                                            <div :class="['week w100',item.week=='六'||item.week=='日'?'zhoumo':'blackFont']" >
                                                {{item.week}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="scrollbox" :style="'height:'+tableHeight+'px'" style="overflow-y: auto;width: fit-content">
                                <div class="person   center wbg">
                                    <span v-if="personList.length==0" class="wushuju">{{waitTxt}}</span>
                                    <template v-else>
                                    <div class=" w100  tablebox j-c-c center">

                                            <div class=" w100  j-c-c" v-for="(person,personIndex) in personList" :key="personIndex">
                                                <div :class="['border  w100  a-i-c psr  flex',personChoose==person.i_uid?'activeBg':'']"  @click="chooseRow(person,personIndex)">
                                                    <span class="blackFont">{{person.vc_uname}}</span>
                                                    <span class="brageP blackFont">{{personIndex+1}}</span>
                                                </div>
                                                <div class="border w100 f-d-c" v-for="(date,dateIndex) in person.fordate" :key="dateIndex">
                                                    <template  v-for="(item,weekIndex) in weekList" >
                                                        <div v-if='item.ymd===date.dt_fordate' :class="['w100']">
                                                            <div :class="[' flex w100 ',bcIndex==1?'borderTop':'']" v-for="(bc,bcIndex) in date.scheduleList" :key="bcIndex">
                                                                <div :class="['ptb5  a-i-c w100  min-h20 psr',activeList.includes(person.i_uid+','+date.dt_fordate+','+bc.i_whichhalf)?'activeBg':'']" @click="singChoose(person,date,bc,personIndex,dateIndex,bcIndex)">
                                                                    <span :class="['lin4',item.week=='六'||item.week=='日'?'zhoumo':'blackFont']">{{bc.vc_bcnote}}</span>
<!--                                                                    <div>-->
                                                                        <span :class="['ccz cczp',item.week=='六'||item.week=='日'?'zhoumo':'smallDarkGrayFont']" v-if="bc.f_outofproduce">{{bc.f_outofproduce}}</span>
                                                                        <span :class="['jx jxp',item.week=='六'||item.week=='日'?'zhoumo':'smallDarkGrayFont']"  v-if="bc.f_planoverhaul">{{bc.f_planoverhaul}}</span>
<!--                                                                    </div>-->

                                                                    <span class="uppoint upposition" v-if="bc.i_fourthwork==2&&bc.i_isfourth==1"></span>
                                                                    <span class="lowpoint lowposition" v-if="bc.i_fourthwork==1&&bc.i_isfourth==1"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                </div>
                                            </div>

                                    </div>
                                    </template>

                                </div>
                            </div>


                        </div>
                   </div>

				</div>
			</div>
			<div :class="baseerp+'div'">
				<el-dialog title="调整循序"
                           width="60%"
                           :visible.sync="tzsxDialog"
                           :close-on-click-modal="false"
                           @close="closetzsxPop">
					<div class="left mTop14">
						<div class="blackFont">{{personName+'的当前顺序为'+personIndex}}</div>
						<div class="flex a-i-c ">
							<span class="flex blackFont">调整到：</span>
                            <!--<el-select  class="plr4" size="mini" filterable  v-model="sxid" @change="sxChange">
                                <el-option v-for="(val,index) in fzPList"  :label="val.vc_name" :value="val.i_id"></el-option>
                            </el-select>
                            <span class="flex blackFont">的前面</span>-->
                            <el-input-number style="width: 220px" size="mini" clearable class="blackFont" :min="1" v-model="sxValue"
                                :controls="false" placeholder="请输入更改顺序" @change="sxChange"></el-input-number>
						</div>
					</div>
					<div class="mTop14 center">
						<el-button class='popCancelBtn' @click="closetzsxPop" :disabled="disableCan">取消</el-button>
						<el-button class='popSaveBtn' @click="tzsxFun" :disabled="disableCan" type="primary">提交</el-button>
					</div>
				</el-dialog>
				<el-dialog :title="'机修时长'+dayChoose"
                           width="60%"
                           top="30px"
                           :visible.sync="jxscDialog"
                           :close-on-click-modal="false"
                           @close="closejxscPop">
                    <save-jxsc  v-if="jxscDialog" :data='tzbzData' @close='closeSave'></save-jxsc>
				</el-dialog>
                <el-dialog :title="'调整班次'+dayChoose"
                           width="60%"
                           top="30px"
                           :visible.sync="tzbcDialog"
                           :close-on-click-modal="false"
                           @close="closeSave">
                    <save-schedule v-if="tzbcDialog" :data='tzbzData' @close='closeSave'></save-schedule>
                </el-dialog>
                <el-dialog :title="'复制 '+dayChoose+' 日班次'"
                           width="60%"
                           top="30px"
                           :visible.sync="fzbcDialog"
                           :close-on-click-modal="false"
                           @close="closeSave">
                    <div class="left mTop14">
                        <span class="blackFont plr4"> 要复制的日期：</span>
                        <el-date-picker type="dates" formate="yyyy-MM-dd" value-format="yyyy-MM-dd"  class="blackFont plr4" v-model="dateList" placeholder="选择要复制的一个或多个日期"></el-date-picker>
                        <div class="mTop14 center">
                            <el-button class='popCancelBtn' @click="closefzbcPop" :disabled="disableCan" size="mini">取消</el-button>
                            <el-button class='popSaveBtn' @click="fzbcFun" :disabled="disableCan" type="primary" size="mini">提交</el-button>
                        </div>
                    </div>

                </el-dialog>
                <el-dialog :title="'复制 '+personName+' 的班次'"
                           width="60%"
                           top="30px"
                           :visible.sync="ryfzbcDialog"
                           :close-on-click-modal="false"
                           @close="closeSave">
                    <div class="left mTop14">
                        <span class="blackFont plr4"> 要复制的人员：</span>
                        <el-select  class="plr4" size="mini" filterable multiple  v-model="fzidList">
                            <el-option v-for="(val,index) in fzPList"  :label="val.vc_name" :value="val.i_id"></el-option>
                        </el-select>
                        <div class="mTop14 center">
                            <el-button class='popCancelBtn' @click="closeryfzbcPop" :disabled="disableCan" size="mini">取消</el-button>
                            <el-button class='popSaveBtn' @click="ryfzbcFun" :disabled="disableCan" type="primary" size="mini">提交</el-button>
                        </div>
                    </div>

                </el-dialog>
				<el-dialog title="部门调整"
                           width="60%"
                           :visible.sync="tzbmDialog"
                           :close-on-click-modal="false"
                           @close="closebmtzPop">
					<div class="left mTop14">
						<div>
							<span class="titleTxt">{{personName+' '}}</span>
							<span class="blackFont"> 部门调整为：</span>
						</div>
                        <el-select v-model="tzgid" placeholder="请选择" size="mini" @change="tzbcChange">
                            <el-option
                                    v-for="item in groupList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
					</div>
					<div class="mTop14 center">
						<el-button class='popCancelBtn' @click="closebmtzPop" :disabled="disableCan" size="mini">取消</el-button>
						<el-button class='popSaveBtn' @click="bmtzFun" :disabled="disableCan" type="primary" size="mini">提交</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
	import SaveSchedule from "./components/SaveSchedule.vue"
	import SaveJxsc from "./components/SaveJxsc.vue"
	export default {
		name: "index",
		components: {SaveSchedule,SaveJxsc},
		data() {
			return {
				showpage:'pbgl',
				tzbzData:{},
                tableHeight: '',
				screenHeight: '',
				weekList:[],
				ymTxt:"",
				activeList:[],
				chooseList:[],
				personChoose:null,
				personIndex:null,
				personName:'',
				personList:[],
				disableCan:false,
				sxValue:null,
                sxid:null,
				gid:sessionStorage.getItem("i_gid"),
				groupList:[],
				contentText:{
					contentdown:'上拉显示更多..',
					contentrefresh:"正在加载...",
					contentnomore:"没有更多数据了..."
				},
				status: 'loading',
				tzbzName:'',
				tzgid:null,
				dayChoose:null,
				jxscData:[],
                tzsxDialog:false,
                tzbcDialog:false,
                fzbcDialog:false,
                ryfzbcDialog:false,
                tzbmDialog:false,
                jxscDialog:false,
                baseerp:'',
                tableData:[],
                dateList:[],
                waitTxt:'',
                searchPeople:[],
                fzPList:[],
                fzidList:[],
                idpeople:'',
                compsData:[],
                companyName:'',
                companyId:0,
                //i_gid:0,
                vc_gname:'',
                //groupName:[],
			}
		},

		mounted() {
		    this.baseerp=baseerp;
            this.getCompanyList();
            let date=new Date();
			this.getDay(date);
			this.getGroupList();
			this.scheduleList();
			this.bcListFun();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-230;
                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
			bcChange(e){
				//console.log(e,'e.detail');
                this.gid=e;
				let choo=this.groupList.filter(i=>i.i_id==e);
				// this.gid=data.i_id;
                if(choo.length>0){
                    this.vc_gname=choo[0].vc_name;
                }else{
                    this.vc_gname='';
                }
                //console.log(this.vc_gname,'this.vc_gname')
				this.activeList=[];
				this.chooseList=[];
				this.personChoose=null;
				this.dayChoose=null;
				this.scheduleList();
				this.bcListFun()
			},
			tzbcChange(){
                let data=this.groupList.find(i=>i.i_id==this.tzgid);
				// this.tzgid=data.i_id;
				// this.tzbzName=data.vc_name
			},
			chooseLine(data,index){
				this.activeList=[];
				this.chooseList=[];
				this.personChoose=null;
				this.dayChoose=data.ymd;
				for(let i=0;i<this.personList.length;i++){
					let person=this.personList[i];
					for(let j=0;j<person.fordate.length;j++){
						let date=person.fordate[j];
						if(date.dt_fordate==data.ymd){
							// console.log(date.dt_fordate,data.ymd,'date.dt_fordate==data.ymd');
							for(let m=0;m<date.scheduleList.length;m++){
								let bc=date.scheduleList[m],
									str=person.i_uid+','+date.dt_fordate+','+bc.i_whichhalf;
									this.activeList.push(str)
							}
						}

					}
				}
			},
			chooseRow(data,index){
				this.activeList=[]
				this.chooseList=[]
				this.dayChoose=null
				this.personChoose=data.i_uid
				this.perorder=data.i_order
				this.personIndex=index+1
				this.personName=data.vc_uname
                // for(let i=0;i<this.personList.length;i++){
                //     let person=this.personList[i];
                    for(let j=0;j<data.fordate.length;j++){
                        let date=data.fordate[j];
                        // if(date.dt_fordate==data.ymd){
                            // console.log(date.dt_fordate,data.ymd,'date.dt_fordate==data.ymd');
                            for(let m=0;m<date.scheduleList.length;m++){
                                let bc=date.scheduleList[m],
                                    str=data.i_uid+','+date.dt_fordate+','+bc.i_whichhalf;
                                this.activeList.push(str)
                            }
                        // }

                    // }
                }
			},
			singChoose(person,date,bc,pi,di,bi){
                if(this.personChoose==null){
                    if(this.dayChoose==null||this.dayChoose==date.dt_fordate){
                        let str=person.i_uid+','+date.dt_fordate+','+bc.i_whichhalf;
                        let index=this.activeList.findIndex(l=>l==str);
                        if(index==-1){
                            this.activeList.push(str)

                        }else{
                            this.activeList.splice(index,1)

                        }
                        if(this.activeList.length==0){
                            this.dayChoose=null
                        }else{
                            this.dayChoose=date.dt_fordate
                        }
                    }else{
                        this.$message.warning('请选择相同日期的工时')
                    }
                }else{
                    this.$message.warning('请选择相同人员的工时')
                }

				// console.log(person.i_uid+','+date.dt_fordate+','+bc.i_whichhalf,'person.i_uid+','+date.dt_fordate+','+bc.i_whichhalf');

			},
			handleData(){
				this.chooseList=[]
				let active=JSON.parse(JSON.stringify(this.activeList))
				for(let i =0;i<active.length;i++){
					let arr=active[i].split(',');
					let p=arr[0],
						d=arr[1],
						b=arr[2];
					let pobj=this.personList.find(pinfo=>pinfo.i_uid==p),dobj,bobj,
						pchoose=this.chooseList.findIndex(pinfo=>pinfo.i_uid==p),dchoose,bchoose,
						phash,dhash;
						// console.log(pobj,p,'ppp');
					if(pobj){
						dobj=pobj.fordate.find(dinfo=>dinfo.dt_fordate==d);
						if(dobj){
							bobj=dobj.scheduleList.find(binfo=>binfo.i_whichhalf==b)
						}
					}
					dhash={
						i_uid:pobj.i_uid,
						vc_uname:pobj.vc_uname,
						i_order:pobj.i_order,
						i_kqtype:pobj.i_kqtype,
						dt_fordate:d,
					}
					// delete bobj.i_id
					phash={
						...dhash,...bobj
					}
					this.chooseList.push(phash)
				}
			},
			tzbz(){
				this.handleData()
				if(this.chooseList.length>0){
					this.tzbzData={
						chooseList:this.chooseList,
						gid:this.gid,
						bcList:this.bcList
					}
					this.tzbcDialog=true
				}else{
					this.$message.warning('请选择要调整的班次')
				}
			},
            fzbz(){
                if(!this.personChoose){
                    this.handleData()
                    this.chooseList=this.chooseList.filter(b=>b.i_bcid!=0)
                    if(this.chooseList.length>0){
                        this.fzbcDialog=true
                    }else{
                        this.$message.warning('请选择要复制的班次')
                    }
                }else{
                    this.$message.warning('请选择要复制的日期')
                }

            },
            fzbcFun() {
               this.duplicateSchedule()
            },
            ryfzbz(){
                if(!this.dayChoose) {
                    this.handleData()
                    this.chooseList = this.chooseList.filter(b => b.i_bcid != 0)
                    if (this.chooseList.length > 0) {
                        this.ryfzbcDialog = true
                        this.getPersonList()
                    } else {
                        this.$message.warning('请选择要复制的班次')
                    }
                }else{
                    this.$message.warning('请选择要复制的人员')
                }
            },
            ryfzbcFun() {
                this.dupScheduleByPeople()
            },
            //部门树
            async getPersonList() {

                // console.log(this.i_kqtcid)
                let params = {
                    i_groupid:this.gid,
                    i_state:1
                }
                let res = await API.getPersonList(params);
                if (res.code == 1) {
                    this.fzPList=res.data
                    // console.log(this.data)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            closefzbcPop(){
                this.fzbcDialog=false
            },
            closeryfzbcPop(){
                this.ryfzbcDialog=false
            },
            closeSave(back='back'){
                this.tzbcDialog=false
                this.jxscDialog=false
                if(back=='save'){
					this.chooseList=[]
					this.activeList=[]
					this.dayChoose=null
					this.scheduleList()
				}
			},
			tzsx(){
				if(this.personChoose){
                    this.getPersonList()
                    this.tzsxDialog=true

                }else{
					this.$message.warning('请选择要调整的人员')
				}
			},
			sxChange(e){
                // let peo=this.fzPList.find(p=>p.i_id==this.sxid);
                // if(this.personName==peo.vc_name){
                //     this.$message.warning('无需调整当前位置')
                //     this.disableCan=true
                //     this.sxValue=null
                // }else{
                //     this.disableCan=false
                //     this.sxValue=peo.i_order
                // }
				if(this.sxValue>this.personList.length){
					this.sxValue=null
					this.$forceUpdate()
					this.$message.warning('调整位置不得大于总人数')
				} else if(this.sxValue==this.personIndex){
					this.$message.warning('无需调整当前位置')
                    this.sxValue=null
                }else if(this.sxValue<=0){
					this.$message.warning('调整位置不存在')
                    this.sxValue=null
                }else{
				}
			},
			tzsxFun(){
				this.sort()
			},
			closetzsxPop(){
                this.tzsxDialog=false

            },
			bmtz(){
				if(this.personChoose){
                    this.tzbmDialog=true
                    // this.dt_fordate=this.chooseList[0].dt_fordate
                    this.tzgid=this.gid
					let data=this.groupList.find(g=>this.tzgid==g.i_id);
					this.tzbzName=data.vc_name
				}else{
					this.$message.warning('请选择要调整的人员')
				}
			},
			closebmtzPop(){
                this.tzbmDialog=false

			},
			jxschandleData(){
				this.jxscData=[]
				this.handleData()
				this.uparr=this.chooseList.filter(f=>f.i_whichhalf==0);
				this.lowarr=this.chooseList.filter(f=>f.i_whichhalf==1);
				let  upnameList=this.uparr.map(n=>n.vc_uname);
				let  lownameList=this.lowarr.map(n=>n.vc_uname);
				upnameList=Array.from(new Set(upnameList));
				lownameList=Array.from(new Set(lownameList));
				let up={
					nameList:upnameList,
					scheduleList:this.uparr,
				},
				low={
					nameList:lownameList,
					scheduleList:this.lowarr,

				}
				// if(upnameList.length>0){
					this.jxscData.unshift(up)
				// }
				// if(lownameList.length>0){
					this.jxscData.push(low)
				// }
				// console.log(this.jxscData,'this.jxscData');
			},
			jxsc(){
				if(this.activeList.length>0){
					this.handleData()
					this.perList=[]
					this.chooseList.map(b=>{
						if(b.i_id!=0&&b.i_bcid!==0&&b.i_iswork!==0){this.perList.push(b.i_uid)}
						// if(b.i_id!=0&&b.i_bcid!==0&&b.i_bcid!==27){this.perList.push(b.i_uid)}

					})
					// console.log(this.perList,'this.perList');
					if(this.perList.length==0){
						this.$message.warning('请先调整班次')
					}else{
						this.tzbzData={
							chooseList:this.chooseList,
							gid:this.gid,
							bcList:this.bcList
						}
						this.jxscDialog=true
                        this.dt_fordate=this.chooseList[0].dt_fordate
                    }

					// this.jxschandleData()
					// this.$refs.jxscPop.open()
				}else{
					this.$message.warning('请选择要录入的工时')
				}
			},
			closejxscPop(){
                this.jxscDialog=false
			},
			bmtzFun(){
				this.changeGroup()
			},
			clearChoose(){
				this.chooseList=[]
				this.activeList=[]
				this.personChoose=null
				this.perorder=null
				this.dayChoose=null
			},
			getDay(val){
				let date=val,
					// weekDays=["周日","周一","周二","周三","周四","周五","周六"],
					weekDays=["日","一","二","三","四","五","六"],
					//获取周几的索引
					dayOfWeekIndex=date.getDay(),
					//获取当天的日期和星期
					dayOfMonth=date.getDay(),
					month=date.getMonth()+1,
					year=date.getFullYear(),
                    dateLength=new Date(year,month,0).getDate(),
					weekList=[];
                for(let i=1;i<=dateLength;i++){
                        // let nextDate=new Date(date.getTime()+((i+1-dayOfWeekIndex)*24*60*60*1000));
                        // const m = nextDate.getMonth() + 1 < 10 ? '0' + (nextDate.getMonth() + 1) : nextDate.getMonth() + 1 // 获取当前月份的日期，不足10补0
                        // const d = nextDate.getDate() < 10 ? '0' + nextDate.getDate() : nextDate.getDate(); // 获取当前几号，不足10补0
                        // console.log(nextDate.getDate(),nextDate.getDay(),"nextDate");
                    const m =month<10?'0'+month:month;
                    const d =i<10?'0'+i:i;
                    weekList.push({
                                week:weekDays[new Date(date.setDate(i)).getDay()],
                                year:year,
                                month:month,
                                day:i,
                                // timeStamp:date.getTime()+((i+1-dayOfWeekIndex)*24*60*60*1000),
                                ymd:year+'-'+m+'-'+d,
                                ym:year+'-'+m,
                            })
                }
					weekList.unshift({
						week:"人员",
						year:"",
						month:"",
						day:"",
					})
					this.weekList=weekList

                this.startdate=this.weekList[1].ymd
					this.enddate=this.weekList[this.weekList.length-1].ymd
					this.ymTxt=this.weekList[1].ym
					// console.log(weekList,"weekList");
			},
			pre(){
				let prem=this.weekList[1].month==1?12:this.weekList[1].month-1,
                    prey=this.weekList[1].month==1?this.weekList[1].year-1:this.weekList[1].year,
                    m =prem<10?'0'+prem:prem,
                    date=prey+'-'+m+'-01',
                    // d =i<10?'0'+i:i,
                    preWeek=new Date(date);
					this.getDay(preWeek)
					this.scheduleList()
				// let nextDate=new Date(date.getTime()+((i+1-dayOfWeekIndex)*24*60*60*1000));
			},
			next(){
                let nextm=this.weekList[1].month==12?1:this.weekList[1].month+1,
                    nexty=this.weekList[1].month==12?this.weekList[1].year+1:this.weekList[1].year,
                    m =nextm<10?'0'+nextm:nextm,
                    date=nexty+'-'+m+'-01',
                    nextWeek=new Date(date);
					this.getDay(nextWeek)
					this.scheduleList()
			},
            //延迟搜索
            namesearch(val){
                this.searchname=val
                this.searchUser()
            },
            //名称搜索
            nameChange(val){
                // console.log(val,'val')
                let obj=this.groupList.find(one=>one.i_id==val);
                if(obj){
                    // this.$nextTick(()=>{
                    // })
                    this.gid=val
                    this.scheduleList();
                    this.bcListFun();
                    // this.$forceUpdate()
                }else{
                    this.$message.error('无权查看');
                    this.gid='';
                    this.searchPeople=[]
                }

            },
            //搜索查询
            async searchUser() {
                let params = {
                    keyname:this.searchname
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
			async scheduleList() {
                this.personList=[]
                this.waitTxt='加载中..'
				// this.otherParam={};
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id);
                } else {
                    this.mid = sessionStorage.getItem('mids');
                }
				this.status="loading";
				let param = {
					i_gid:this.gid,
					dt_startdate:this.startdate,
					dt_enddate:this.enddate
				}


				// this.otherParam=param;
				let res = await API.scheduleList(param)
				if (res.code == 1) {
					this.personList=res.data
                    if(this.personList.length==0){
                        this.waitTxt='暂无数据'
                    }
				}else{
					this.$message.error(res.message)
                    this.waitTxt='暂无数据'

                }
			},
			//排序
			async sort() {
				// let that=this
				// this.otherParam={};
				// this.status="loading";
                if(this.sxValue!=null){
                    this.disableCan=true
                    let param = {
                        i_gid:this.gid,
                        i_memberid:this.personChoose,
                        i_order:this.sxValue,
                        i_origin_order:this.perorder,
                        i_origin_index:this.personIndex,
                    }
                    // this.otherParam=param;
                    let res = await API.sort(param)
                    if (res.code == 1) {
                        this.disableCan=false
                        this.$message.success(res.message)
                        this.closetzsxPop()
                        this.sxValue=null
                        this.sxid=null
                        this.chooseList=[]
                        this.activeList=[]
                        this.dayChoose=null
                        this.personChoose=null
                        this.perorder=null
                        this.scheduleList()
                    }else{
                        this.disableCan=false
                        this.closetzsxPop()
                        this.sxValue=null
                    }
                }else{
                    this.$message.warning('请选择人名')
                }

			},
			//更换班组
			async changeGroup() {
                this.disableCan=true
                let param = {
					i_memberid:this.personChoose,
					i_gid:this.tzgid,
				}
				// this.otherParam=param;
				let res = await API.changeGroup(param)
				if (res.code == 1) {
				    this.$message.success(res.message)
                    this.disableCan=false
                    this.closebmtzPop()
                    this.chooseList=[]
                    this.activeList=[]
                    this.dayChoose=null
                    this.personChoose=null
                    this.perorder=null
                    this.scheduleList()
				}else{
                    this.disableCan=false
                    this.$message.error(res.message)
					this.closebmtzPop()
				}
			},
            changeData(e,type){
                //console.log(e,type);
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                    this.gid=0;
                    this.vc_gname='';
                    this.groupList=[];
                    //this.i_squid=0;
                    //this.vc_squname='';
                    //this.personName=[];
                    this.getGroupList();
                }
                if(type=='bm'){
                    this.gid=e;
                    let choo = this.groupList.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_gname=choo[0].vc_name;
                    }else{
                        this.vc_gname='';
                    }
                    //this.i_squid=0;
                    //this.vc_squname='';
                    //this.personName=[];
                    //this.getPersonList(this.?this.:0)
                }
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                    this.gid=0;
                    this.vc_gname='';
                    //this.i_squid=0;
                    //this.vc_squname='';
                    //this.personName=[];
                    this.groupList=[];
                }
                if(type=='bm'){
                    this.gid=0;
                    this.vc_gname='';
                    //this.i_squid=0;
                    //this.vc_squname='';
                    //this.personName=[];
                }
                this.scheduleList();
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.companyId?this.companyId:0,
                    //isAll:1
                    isNoRight:0,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupList=res.data;
                    if(res.data.length==1){
                        this.gid=res.data[0].i_id;
                        this.vc_gname=res.data[0].vc_name;
                        //this.getPersonList(this.?this.:0)
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                    if(res.data.length>0){
                        this.companyId=res.data[0].i_id;
                        this.companyName=res.data[0].vc_name;
                        this.getGroupList()
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
			/*async getGroupList() {
				let param = {
					i_type:0,
				}
				// this.otherParam=param;
				let res = await API.getGroupList(param)
				if (res.code == 1) {
					this.groupList=res.data;
					this.$nextTick(()=>{
                        this.gid=sessionStorage.getItem("i_gid")

                    })
                    console.log(this.gid,'sessionStorage')
                }
			},*/
			async bcListFun() {
				let param = {
					i_gid:this.gid
				};
				// this.otherParam=param;
				let res = await API.bcList(param);
				if (res.code == 1) {
					this.bcList=res.data
					}
			},
			async duplicateSchedule(){
                this.disableCan=true
                let param={
                    dt_fordate:this.dateList,
                    scheduleList:this.chooseList
                };
				// let param = {
				// 	data:data
				// };
                // console.log(data,'data')
				let res = await API.duplicateSchedule(param);
				if (res.code == 1) {
                    this.dateList=[]
				    this.$message.success(res.message);
                    this.disableCan=false;
                    this.fzbcDialog=false;
                    this.chooseList=[];
                    this.activeList=[];
                    this.dayChoose=null;
                    this.personChoose=null;
                    this.perorder=null;
                    this.scheduleList();
					// this.bcList=res.data
                }else{
				    this.$message.error(res.message)
                    this.disableCan=false

                }
			},
            async dupScheduleByPeople(){
                this.disableCan=true
                let param={
                    toUser:this.fzidList,
                    scheduleList:this.chooseList
                };
                // let param = {
                // 	data:data
                // };
                // console.log(data,'data')
                let res = await API.dupScheduleByPeople(param);
                if (res.code == 1) {
                    this.fzidList=[]
                    this.$message.success(res.message);
                    this.disableCan=false
                    this.ryfzbcDialog=false;
                    this.chooseList=[];
                    this.activeList=[];
                    this.dayChoose=null;
                    this.personChoose=null;
                    this.perorder=null;
                    this.scheduleList();
                    // this.bcList=res.data
                }else{
                    this.$message.error(res.message)
                    this.disableCan=false

                }
            }
		},
	}
</script>

<style lang="scss" scoped>
    .p4{
        padding: 4px 5px !important;
    }
    .ccz{
        background-color:#2882ff ;
        color: #fff;
        border: 1px solid #2882ff;
        padding:0 2px;
        display: inline-block;
        /*margin-right: 4px;*/
font-size: 12px;
        border-radius: 4px;
    }
    .cczp{
        position: absolute;
        top: 0;
        left: 0;
    }
    .jx{
        font-size: 12px;

        display: inline-block;
        padding:0 2px;
        border: 1px solid #E65050;
        background-color:#E65050 ;
        color: #fff;
        border-radius: 4px;
    }
    .jxp{
        position: absolute;
        bottom: 0;
        left: 0;
    }
    .person::-webkit-scrollbar{
        display: none;
    }
    .overBox{
        overflow-x: auto;
        width: 100%;
    }
    span{
        font-size: 14px;
    }
    .blackFont{

    }
    .pall14{
        padding: 14px;
    }
    .flex{
        display: flex;
    }
	.plr4{
		padding-left:4px ;
		padding-right:4px ;
	}
	.min-h20{
		min-height:40px;
        max-height: 40px;
	}
    .lin4{
        line-height: 40px;
    }
	.mt8{
		margin-top: 8px;
	}
	.clearBtn{
		position: absolute;
		right: 6px;
		top: 7px;
		cursor: pointer;
	}
	.p14{
		// padding-bottom: 14px;
		padding-left: 6px;
		padding-right: 6px;
	}
	.ptb5{
		padding-top:5px ;
		padding-bottom:5px ;
	}
	.f-d-c{flex-direction: column;}
	.j-c-c{
		justify-content: center;
	}
	.a-i-c{
		align-items: center;
	}
    .calendarBox{
        /*overflow: hidden;*/
        box-sizing:border-box;
        font-size: 14px;
        overflow-x: auto;
        position: relative;

    }
    .calendar{
        /*overflow: hidden;*/
        /*width: 100%;*/
        position: sticky;
        top: 0;
    }
    .tablebox{
        /*display: table;*/
        text-indent: initial;
        table-layout: fixed;
    }
    .wushuju{
        position: absolute;
        top: 70px;
        left: 0;
        right: 0;
    }
    .person{
        /*overflow: hidden;*/
        width: 100%;
        /*overflow-y:auto ;*/
        /*overflow-x: visible;*/

    }
    .scrollbox::-webkit-scrollbar{
        display: none;
    }
	.border{
		border: 1px solid #ccc;
        min-width: 55px;
        display: table-cell;
        vertical-align: middle;
	}
	.borderTop{
		border-top: 1px solid #ccc;
	}
	.w100{
		width: 100%;
	}
	.w50{
		width: 50%;
	}
	.left{
		text-align: left;
	}
	.center{
		text-align: center;
	}
	.wbg{
		background-color: #fff;
	}
	.activeBg{
		background-color: #eeedad;
	}
    .guding{
        /*position: sticky;*/
        /*left: 0;*/
    }
	.psr{
		position: relative;
	}
	.pointnote{
        position: absolute;
        right: 6px;
        top: 18px;
	}
    .daynote{
        position: absolute;
        left: 6px;
        top: 18px;
    }
	.brageP{
		position: absolute;
		top: -3px;
		right: 1px;
		font-size: 14px;
		// font-size: 14px !important;
	}

	.uni-calendar__header {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		justify-content: center;
		align-items: center;
		height: 50px;

	}
	.uni-calendar__header-btn-box {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 50px;
		height: 50px;
	}

	.uni-calendar__header-btn {
		width: 10px;
		height: 10px;
		border-left-color: #ccc;
		border-left-style: solid;
		border-left-width: 2px;
		border-top-color: #ccc;
		border-top-style: solid;
		border-top-width: 2px;
	}

	.uni-calendar--left {
		transform: rotate(-45deg);
	}

	.uni-calendar--right {
		transform: rotate(135deg);
	}
	// /deep/.uni-easyinput__content{
	// 	height: 30px !important;
	// }
	.pick{
		height: 100%;
		vertical-align: middle;
	}
	.mTop14{
		margin-top: 24px;
	}
	.pop button{
		background: none;
	}
	.right{
		width: 100%;
		text-align: right;
	}
	.labelWidth{
		flex:0 0 85px;
	}
	/deep/.uni-easyinput__content-input{
		height: 0 !important;
	}
	.jxscpop .uni-easyinput{
		flex: unset;
	}
	.Button{
		// background-color: #eb5a55;
		// height: 36px;
		/*line-height: 1.5;*/
		/*border-radius: 8px;*/
		/*margin: 0px 3px;*/
		/*font-size: 16px;*/
		color: #fff;
		/*font-weight: 500;*/
		/*!*width: 100%;*!*/
		/*text-align: center;*/
		/*display: inline-block;*/
		/*padding: 9px;*/
	}
	.colortzbc{
		background-color: #fa911e;
	}
    .colorfzbc{
        background-color: #36cb85;
    }
	.colortzsx{
		background-color: #1ebed2;
	}
	.colorjxsc{
		background-color: #E65050;
	}
	.colorbmtz{
		background-color: #2882ff;
	}
	.whiteRow{
		background-color: #ffffff;
		border-top: 2px solid #ccc;
		padding: 9px 3px;
	}
	.uppoint{
		display: inline-block;
		border:4px solid #2882ff;
		border-radius: 50%;

	}
	.upposition{
		position: absolute;
		top: 0;
		right: 0;
	}
	.lowpoint{
		display: inline-block;
		border:4px solid #E65050;
		border-radius: 50%;

	}
	.lowposition{
		position: absolute;
		bottom: 0;
		right: 0;
	}
	.zhoumo{
		color: #E65050;
	}
	/deep/.uni-picker-container .uni-picker-item{
		height: unset;
		text-overflow: unset;
		white-space: break-spaces;
	}
	.uni-picker-container .uni-picker-item{
		height: unset;
		text-overflow: unset;
		white-space: break-spaces;
	}
</style>
